import React from 'react';
import { PWGOrder } from 'src/features/common/types/application/pgw';

export enum Status {
  FAILED = 'FAILED',
  SUCCESSFUL = 'SUCCESSFUL',
  CANCELLED = 'CANCELLED',
}

export type PaymentRedirectCaptureProps = {
  isWaitingForPayment: boolean;
  onPaymentEnded: (status: Status, orderNumber: string) => any;
  pgwOrder?: PWGOrder;
};

export function PaymentRedirectCapture(props: PaymentRedirectCaptureProps) {
  // status query param
  const TRANSACTION_CANCELLED = 'TRANSACTION_CANCELLED';
  const TRANSACTION_SUCCESS = 'Success';
  const TRANSACTION_FAILED = 'PAYMENT_FAILED';

  // origin query Param
  const VPG = 'VPG';

  // channel query param
  const WEB = 'web';

  React.useEffect(() => {
    const transactionStatus = props.pgwOrder?.status;
    const transactionOrigin = props.pgwOrder?.origin;
    const transactionChannel = props.pgwOrder?.channel;
    const transactionOrderNumber = props.pgwOrder?.orderNo;

    if (
      props.isWaitingForPayment &&
      transactionStatus &&
      transactionOrderNumber &&
      transactionOrigin === VPG &&
      transactionChannel === WEB
    ) {
      switch (transactionStatus) {
        case TRANSACTION_SUCCESS: {
          props.onPaymentEnded(Status.SUCCESSFUL, transactionOrderNumber);
          break;
        }
        case TRANSACTION_FAILED: {
          props.onPaymentEnded(Status.FAILED, transactionOrderNumber);
          break;
        }
        case TRANSACTION_CANCELLED: {
          props.onPaymentEnded(Status.CANCELLED, transactionOrderNumber);
          break;
        }
      }
    }
  }, [props.pgwOrder, props.isWaitingForPayment]);

  return <></>;
}
